import React = require('react');
import DesignTokens from '@tableau/design-tokens';
import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import { Tooltip } from '@tableau/widgets';

import { applyColor } from '~src/style/ColorService';

import { tooltipButtonStyle, tooltipStyle } from './ExtensionsSectionStyle';

export interface TooltipProps {
  testId: string;
  content: string;
  // Accessible name for the tooltip trigger button. Defaults to the tooltip
  // content so the button always has a programmatic name (WCAG 4.1.2).
  label?: string;
}

export function QuickTooltip(props: TooltipProps) {
  // The trigger is a real <button> so assistive technology exposes the button
  // role and it is keyboard operable (WCAG 4.1.2). The icon is decorative
  // (alt='') because the button's aria-label carries the accessible name.
  // when tooltip plumbs through testId, delete this comment and data-tb-test-id applied to the button tag below
  return <Tooltip
    testId={props.testId}
    getContent={ () => {
      return <span>{props.content}</span>;
    }}>
    <button type={'button'} data-tb-test-id={props.testId} className={tooltipButtonStyle} aria-label={props.label || props.content}>
      <NotificationInfoOutlineIcon className={tooltipStyle} size={16} color={applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c')} alt={''} />
    </button>
  </Tooltip>;
}
